import { CardAnimations, VodSimpleCard } from '@setplex/arcana'
import type { ShowWithPrice } from '~/shared/interfaces'
import {
  VodCardHorizontalCoversMap,
  VodCardVerticalCoversMap,
} from '~/shared/ui/components/cardCovers'
import { type ViewRow } from '../../model'
import { getCardContentPadding, getCategoryId } from '../lib'

export const TvShowCard = ({
  row,
  item,
}: {
  row: ViewRow
  item: ShowWithPrice
}) => {
  const {
    landscapeImageUrl,
    portraitImageUrl,
    free,
    rented,
    name,
    id,
    labelPrice,
    vertical,
  } = item

  const {
    appearance: {
      style: { posterSize, posterOrientation },
      resource: { search },
    },
  } = row

  const contentPadding = getCardContentPadding(posterSize)

  const categoryId = getCategoryId(search)

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? landscapeImageUrl : portraitImageUrl

  const covers =
    posterOrientation === 'HORIZONTAL'
      ? VodCardHorizontalCoversMap
      : VodCardVerticalCoversMap

  return (
    <a href={`/shows/${id}?categoryId=${categoryId}`}>
      <VodSimpleCard
        childrenTransition={CardAnimations.FadeIn}
        lazyImage={false}
        type={posterOrientation}
        posterUrl={posterUrl}
        free={free}
        rented={rented}
        title={name}
        purchaseTitle={labelPrice}
        contentPadding={contentPadding}
        covers={covers}
        verticalVideo={vertical}
      />
    </a>
  )
}
